"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlsForDataServiceId = exports.requestRedstonePayload = exports.getDecimalsForDataFeedId = exports.parseDataPackagesResponse = exports.requestDataPackages = exports.calculateHistoricalPackagesTimestamp = exports.getDataServiceIdForSigner = exports.getOracleRegistryState = void 0;
const oracles_smartweave_contracts_1 = require("@redstone-finance/oracles-smartweave-contracts");
const protocol_1 = require("@redstone-finance/protocol");
const axios_1 = __importDefault(require("axios"));
const data_services_urls_1 = require("./data-services-urls");
const utils_1 = require("@redstone-finance/utils");
const zod_1 = require("zod");
const GET_REQUEST_TIMEOUT = 10000;
const WAIT_FOR_ALL_GATEWAYS_TIME = 600;
const MILLISECONDS_IN_ONE_MINUTE = 60 * 1000;
const GwResponseSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.array(zod_1.z.object({
    dataPoints: zod_1.z
        .array(zod_1.z
        .object({
        dataFeedId: zod_1.z.string(),
        value: zod_1.z.number(),
        decimals: zod_1.z.number().optional(),
    })
        .or(zod_1.z.object({
        dataFeedId: zod_1.z.string(),
        value: zod_1.z.string(),
        decimals: zod_1.z.number().optional(),
    })))
        .min(1),
    timestampMilliseconds: zod_1.z.number(),
    signature: zod_1.z.string(),
    dataFeedId: zod_1.z.string(),
})));
const getOracleRegistryState = async () => {
    return await Promise.resolve(oracles_smartweave_contracts_1.redstoneOraclesInitialState);
};
exports.getOracleRegistryState = getOracleRegistryState;
const getDataServiceIdForSigner = (oracleState, signerAddress) => {
    for (const nodeDetails of Object.values(oracleState.nodes)) {
        if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) {
            return nodeDetails.dataServiceId;
        }
    }
    throw new Error(`Data service not found for ${signerAddress}`);
};
exports.getDataServiceIdForSigner = getDataServiceIdForSigner;
const calculateHistoricalPackagesTimestamp = (deviationCheckOffsetInMinutes, baseTimestamp = Date.now()) => {
    if (deviationCheckOffsetInMinutes > 0) {
        return (Math.floor(baseTimestamp / MILLISECONDS_IN_ONE_MINUTE -
            deviationCheckOffsetInMinutes) * MILLISECONDS_IN_ONE_MINUTE);
    }
    return undefined;
};
exports.calculateHistoricalPackagesTimestamp = calculateHistoricalPackagesTimestamp;
const requestDataPackages = async (reqParams) => {
    try {
        const promises = prepareDataPackagePromises(reqParams);
        if (reqParams.historicalTimestamp) {
            return await Promise.any(promises);
        }
        return await getTheMostRecentDataPackages(promises);
    }
    catch (e) {
        const errMessage = `Request failed ${JSON.stringify({
            reqParams,
        })}, Original error: ${utils_1.RedstoneCommon.stringifyError(e)}`;
        throw new Error(errMessage);
    }
};
exports.requestDataPackages = requestDataPackages;
const getTheMostRecentDataPackages = (promises) => {
    return new Promise((resolve, reject) => {
        const collectedResponses = [];
        const errors = [];
        let waitForAll = true;
        const timer = setTimeout(() => {
            waitForAll = false;
            checkResults();
        }, WAIT_FOR_ALL_GATEWAYS_TIME);
        const checkResults = () => {
            if (errors.length === promises.length) {
                clearTimeout(timer);
                reject(new AggregateError(errors));
            }
            else if (collectedResponses.length + errors.length === promises.length ||
                (!waitForAll && collectedResponses.length !== 0)) {
                const newestPackage = collectedResponses.reduce((a, b) => {
                    const aTimestamp = Object.values(a).at(0)?.at(0)?.dataPackage.timestampMilliseconds ??
                        0;
                    const bTimestamp = Object.values(b).at(0)?.at(0)?.dataPackage.timestampMilliseconds ??
                        0;
                    return bTimestamp > aTimestamp ? b : a;
                });
                clearTimeout(timer);
                resolve(newestPackage);
            }
        };
        for (const promise of promises) {
            promise
                .then((r) => collectedResponses.push(r))
                .catch((e) => errors.push(e))
                .finally(checkResults);
        }
    });
};
const prepareDataPackagePromises = (reqParams) => {
    const urls = (0, exports.getUrlsForDataServiceId)(reqParams);
    const pathComponents = [
        "data-packages",
        reqParams.historicalTimestamp ? "historical" : "latest",
        reqParams.dataServiceId,
    ];
    if (reqParams.historicalTimestamp) {
        pathComponents.push(`${reqParams.historicalTimestamp}`);
    }
    return urls.map((url) => axios_1.default
        .get([url.replace(/\/+$/, "")].concat(pathComponents).join("/"), { timeout: GET_REQUEST_TIMEOUT })
        .then((response) => (0, exports.parseDataPackagesResponse)(response.data, reqParams)));
};
const parseDataPackagesResponse = (responseData, reqParams) => {
    const parsedResponse = {};
    utils_1.RedstoneCommon.zodAssert(GwResponseSchema, responseData);
    const requestedDataFeedIds = reqParams.dataFeeds ?? [protocol_1.consts.ALL_FEEDS_KEY];
    for (const dataFeedId of requestedDataFeedIds) {
        const dataFeedPackages = responseData[dataFeedId];
        if (!dataFeedPackages) {
            throw new Error(`Requested data feed id is not included in response: ${dataFeedId}`);
        }
        if (dataFeedPackages.length < reqParams.uniqueSignersCount) {
            throw new Error(`Too few unique signers for the data feed: ${dataFeedId}. ` +
                `Expected: ${reqParams.uniqueSignersCount}. ` +
                `Received: ${dataFeedPackages.length}`);
        }
        parsedResponse[dataFeedId] = pickDataFeedPackagesClosestToMedian(dataFeedPackages, reqParams.uniqueSignersCount);
    }
    return parsedResponse;
};
exports.parseDataPackagesResponse = parseDataPackagesResponse;
const pickDataFeedPackagesClosestToMedian = (dataFeedPackages, count) => {
    const median = utils_1.MathUtils.getMedian(dataFeedPackages.map((dp) => dp.dataPoints[0].value));
    return sortByDistanceFromMedian(dataFeedPackages, median)
        .map((diff) => protocol_1.SignedDataPackage.fromObj(diff.dp))
        .slice(0, count);
};
function sortByDistanceFromMedian(dataFeedPackages, median) {
    return dataFeedPackages
        .map((dp) => ({
        dp: dp,
        diff: utils_1.SafeNumber.createSafeNumber(dp.dataPoints[0].value)
            .sub(median)
            .abs(),
    }))
        .sort((first, second) => first.diff.sub(second.diff).unsafeToNumber());
}
const getDecimalsForDataFeedId = (dataPackages) => {
    const firstDecimal = dataPackages[0].dataPoints[0]
        .decimals;
    const areAllDecimalsEqual = dataPackages.every((dataPackage) => dataPackage.dataPoints.every((dataPoint) => dataPoint.decimals === firstDecimal));
    if (!areAllDecimalsEqual) {
        throw new Error("Decimals from data points in data packages are not equal");
    }
    return firstDecimal;
};
exports.getDecimalsForDataFeedId = getDecimalsForDataFeedId;
const requestRedstonePayload = async (reqParams, format = "hex", unsignedMetadataMsg) => {
    const signedDataPackagesResponse = await (0, exports.requestDataPackages)(reqParams);
    const signedDataPackages = Object.values(signedDataPackagesResponse).flat();
    const payload = new protocol_1.RedstonePayload(signedDataPackages, unsignedMetadataMsg ?? "");
    switch (format) {
        case "json":
            return JSON.stringify(payload.toObj(), null, 2);
        case "bytes":
            return JSON.stringify(Array.from(payload.toBytes()));
        default:
            return payload.toBytesHexWithout0xPrefix();
    }
};
exports.requestRedstonePayload = requestRedstonePayload;
const getUrlsForDataServiceId = (reqParams) => {
    if (reqParams.urls) {
        return reqParams.urls;
    }
    return (0, data_services_urls_1.resolveDataServiceUrls)(reqParams.dataServiceId);
};
exports.getUrlsForDataServiceId = getUrlsForDataServiceId;
exports.default = {
    getOracleRegistryState: exports.getOracleRegistryState,
    requestDataPackages: exports.requestDataPackages,
    getDataServiceIdForSigner: exports.getDataServiceIdForSigner,
    requestRedstonePayload: exports.requestRedstonePayload,
    resolveDataServiceUrls: data_services_urls_1.resolveDataServiceUrls,
    getDecimalsForDataFeedId: exports.getDecimalsForDataFeedId,
};
__exportStar(require("./contracts/ContractParamsProvider"), exports);
__exportStar(require("./contracts/ContractParamsProviderMock"), exports);
__exportStar(require("./contracts/IContractConnector"), exports);
__exportStar(require("./contracts/prices/IPricesContractAdapter"), exports);
__exportStar(require("./data-feed-values"), exports);
__exportStar(require("./data-services-urls"), exports);
__exportStar(require("./fetch-data-packages"), exports);
__exportStar(require("./simple-relayer/IPriceFeedContractAdapter"), exports);
__exportStar(require("./simple-relayer/IPriceManagerContractAdapter"), exports);
__exportStar(require("./simple-relayer/start-simple-relayer"), exports);
//# sourceMappingURL=index.js.map